import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ChevronRight, ExpandMore, Folder, FolderOpen } from '@material-ui/icons';
import { Alert, TreeView } from '@material-ui/lab';
import { useFileTreeManager } from '../hooks/useFileTreeManager';
import FileExplorerItem from './FileExplorerItem';
const StyledTreeView = styled(TreeView) `
  flex-grow: 1;
`;
const defaultExpandIcon = (React.createElement(React.Fragment, null,
    React.createElement(ChevronRight, null),
    React.createElement(Folder, null)));
const defaultCollapseIcon = (React.createElement(React.Fragment, null,
    React.createElement(ExpandMore, null),
    React.createElement(FolderOpen, null)));
const defaultEndIcon = (React.createElement(React.Fragment, null,
    React.createElement(ChevronRight, null),
    React.createElement(Folder, null)));
// remove trash directory
export function filterFileTree(files, hideTrashDir = false) {
    return files.filter(file => {
        const isTrash = file.name === 'Trash' && file.isLocked;
        return !(hideTrashDir && isTrash);
    });
}
const FileExplorer = props => {
    const { selected: initialSelected, minHeight, hideRootDir, hideTrashDir, includeFiles, onSelectFile } = props;
    const manager = useFileTreeManager();
    const [selected, setSelected] = useState(initialSelected);
    // root folder id is null
    const [expanded, setExpanded] = useState(hideRootDir ? [] : ['null']);
    const { loadFile } = manager;
    const { file: rootFolder, children, isLoading, error } = manager.find(null);
    useEffect(() => {
        setSelected(initialSelected);
    }, [initialSelected]);
    // don't include manager in deps to avoid infinite calls
    useEffect(() => {
        loadFile(null, { isFolderOnly: !includeFiles });
    }, [loadFile, includeFiles]);
    const toggleExpand = (nodeId) => {
        // add to expanded if not exists
        const newExpanded = Array.from(expanded);
        const index = newExpanded.indexOf(nodeId);
        if (index < 0) {
            newExpanded.push(nodeId);
        }
        else {
            newExpanded.splice(index, 1);
        }
        setExpanded(newExpanded);
    };
    // recursive render
    const renderTree = (file, selectedNodeId) => (React.createElement(FileExplorerItem, { file: file, key: `${file.id}`, manager: manager, hideTrashDir: hideTrashDir, includeFiles: includeFiles, selected: `${file.id}` === selectedNodeId, renderTree: file => renderTree(file, selectedNodeId), onSelectNode: (nodeId, file) => {
            // onNodeToggle doesn't call on leaf nodes, so set selected here instead
            setSelected(nodeId);
            toggleExpand(nodeId);
            onSelectFile === null || onSelectFile === void 0 ? void 0 : onSelectFile(file, nodeId);
        } }));
    // content to render
    let content = React.createElement(React.Fragment, null);
    if (isLoading && !rootFolder) {
        content = React.createElement("div", null, "Loading...");
    }
    else if (error) {
        content = (React.createElement("div", null,
            React.createElement(Alert, { severity: 'error' }, error.message)));
    }
    else if (!rootFolder) {
        content = React.createElement("div", null, "No files to show.");
    }
    else {
        content = (React.createElement(StyledTreeView, { expanded: expanded, style: { minHeight }, selected: selected || '', defaultEndIcon: defaultEndIcon, defaultExpandIcon: defaultExpandIcon, defaultCollapseIcon: defaultCollapseIcon }, !hideRootDir
            ? renderTree(rootFolder, selected)
            : filterFileTree(children, hideTrashDir).map(file => {
                return renderTree(file, selected);
            })));
    }
    return content;
};
export default FileExplorer;
//# sourceMappingURL=FileExplorer.js.map